import React from 'react';
import Stepper from 'components/Stepper';
import { useSelector } from 'react-redux';
import { PageHeading } from '@triumph/shared';
import useLabel from 'src/hooks/useLabel';
import { getLabels, getStep, getSummary } from 'src/redux/app/selectors';
import StepOne from 'components/_steps/StepOne';
import StepTwo from 'components/_steps/StepTwo';
import StepThree from 'components/_steps/StepThree';
import StepFour from 'components/_steps/StepFour';
import Label from 'components/_utility/Label';
import { Page, HeadingWrap, Wrap, Terms, TermsInner, TermsTitle, TermsBody } from './StepSwitch.styled';

const StepSwitch = () => {
  const getLabel = useLabel();
  const labels = useSelector(getLabels);
  const activeStep = useSelector(getStep);
  const stepSummary = useSelector(getSummary);

  const steps = [StepOne, StepTwo, StepThree, StepFour];
  const StepComponent = steps[activeStep];

  const pageHeading = (
    <PageHeading
      title={StepComponent === StepFour ? stepSummary.content.summaryTitle : getLabel('formTitle')}
      description={StepComponent === StepFour ? stepSummary.content.summaryDescription : getLabel('formIntro')}
    />
  );

  return (
    <Page>
      <HeadingWrap desktop>{pageHeading}</HeadingWrap>
      <Stepper></Stepper>
      <HeadingWrap mobile>{pageHeading}</HeadingWrap>
      <Wrap>
        <StepComponent />
        {labels.termsTitle && labels.termsDescription && (
          <Terms>
            <TermsInner>
              <TermsTitle>
                <Label name="termsTitle"></Label>
              </TermsTitle>
              <TermsBody dangerouslySetInnerHTML={{ __html: getLabel('termsDescription') }}></TermsBody>
            </TermsInner>
          </Terms>
        )}
      </Wrap>
    </Page>
  );
};

export default StepSwitch;
